const keywords = [
  "story",
  "stories",
  "fiction",
  "social media",
  "storytelling",
  "storyteller",
  "write",
  "writer",
  "writers",
  "writing",
  "read",
  "reader",
  "readers",
  "reading",
  "author",
  "authors",
  "publish",
  "publisher",
  "publishing",
  "short story",
  "novel",
  "flash fiction",
  "twitterature",
  "horror",
  "literature",
  "mystery",
  "bizarro",
  "realism",
  "realistic",
  "raw",
  "uncooked",
].join(", ");

module.exports = keywords;
